
import {
  Vue,
  Component,
  Prop,
  PropSync,
  Watch,
  Inject,
} from "vue-property-decorator";
import Marquee from "@/components/semantics/Marquee.vue";
import SortHeader from "@/components/base/table/header/SortHeader.vue";
import { Action, Getter } from "vuex-class";
import Table from "@/components/base/table/body/TableBoxText.vue";
import Pagination from "@components/base/pagination/PcmPagination.vue";
import { deepClone, getParentArea } from "@/common/utils";
import {
  allCityNum,
  getAddressItemNum,
  nature,
  getDeptNumber,
} from "@/api/common";
@Component({
  name: "Apply",
  components: {
    Marquee,
    SortHeader,
    Table,
    Pagination,
  },
})
export default class Apply extends Vue {
  @Action("policy/getApplyList") private getApplyList: any;
  @Getter("cityName") private cityName: any;
  @Getter("cityId") private cityId: any;
  @Getter("city") private city: any;
  @Getter("provinceId") private provinceId: any;
  areaOption = this.$root.$data.areaOption;
  loading = false;
  tableData: any = [];
  searchValue: any = "";
  total = 0;
  pages = 0;
  current = 1;
  size = 12;
  current_option: any = {};
  proviceArr: Array<any> = [];
  cityArr: Array<any> = [];
  townArr: Array<any> = [];
  policyTypeArr: Array<any> = [];
  deptArr: Array<any> = [];
  declareStatusArr:  Array<any> = [
    {
      name: "全部",
      id: "",
    },
    {
      id: 1,
      name: '未开始'
    },
    {
      id: 2,
      name: '兑现中'
    },
    {
      id: 3,
      name: '已截止'
    }
  ];
  declareStatus: any = "";
  currentProvince: any = "";
  currentCity: any = "";
  currentTown: any = "";
  currentType: any = "全部";
  currentDept: any = "";
  currentYear: any = "";
  yearTypeArr: any = [
    {
      year: "全部",
      val: "",
    },
    {
      year: new Date().getFullYear(),
      val: new Date().getFullYear(),
    },
    {
      year: new Date().getFullYear() - 1,
      val: new Date().getFullYear() - 1,
    },
    {
      year: new Date().getFullYear() - 2,
      val: new Date().getFullYear() - 2,
    },
  ];
  fundRangeArr: any = [
    {
      fundRange: "不限",
      value: "",
    },
    {
      fundRange: "200~1000元",
      value: "200~1000元",
    },
    {
      fundRange: "1001~10000元",
      value: "1001~10000元",
    },
    {
      fundRange: "10001~100000元",
      value: "10001~100000元",
    },
    {
      fundRange: "100001~5000000元",
      value: "100001~5000000元",
    },
    {
      fundRange: "5000001~50000000元",
      value: "5000001~50000000元",
    },
  ];
  currentFundRange: any = "";
  startSupportAmount: any = "";
  endSupportAmount: any = "";
  title: any = "";
  created() {
    this.getAreaOption()
    this.getData(0);
  }
  currentChange(params: any) {
    this.current = params;
    this.getData(1);
  }
  async getData(type: any) {
    // 0-default|1-search
    this.loading = true;

    let options: any = {
      pageNumber: this.current,
      pageSize: this.size,
      order: "desc",
      sort: "releaseDate",
      locationAddressCode: this.city.locationAddressCode,
      addressCode: this.currentTown
        ? this.currentTown
        : this.currentCity
          ? this.currentCity
          : this.currentProvince,
      departmentId: this.currentDept,
      nature: this.currentType == "全部" ? "" : this.currentType,
      all: this.currentProvince == "" ? "" : 1,
      year: this.currentYear,
      state: this.declareStatus,
      startSupportAmount: this.startSupportAmount,
      endSupportAmount: this.endSupportAmount,
    };
    if (type === 1) {
      options = {
        ...options,
        ...this.current_option,
      };
    } else {
      if (!this.city.locationAddressCode) {
        options.addressCode = this.city.id;
      }
      options = {
        ...options,
      };
    }
    console.log(options, 8877777)
    this.getApplyList(options)
      .then(({ code, result, msg }: any) => {
        if (code === 200) {
          this.loading = false;
          const { total, records, pages } = result;
          const policy_arr: any = [];
          this.tableData = records.map(
            ({ nature, state, supportAmount, ...item }: any) => {
              const money = `${
                supportAmount ? (supportAmount / 10000).toFixed(0) : 0
              }万元`;

              let stateWord = ["", "未开始", "兑现中", "已截止"];
              state = stateWord[state];
              return {
                tags: [money, nature, state],
                ...item,
              };
            }
          );

          this.total = total;
          this.pages = pages;
        }
      })
      .catch((err: any) => err)
      .finally(() => (this.loading = false));
  }
  // 获取城市信息
  async getAreaOption() {
    const res: any = await allCityNum()
      .then()
      .catch((e: string) => console.error(e));
    const { code, result, msg } = res.data;
    console.log(result,333333)
    let filterArr = result.filter((item: any) => item.name == "湖北省");
    this.proviceArr = [
      { name: "全部", id: "" },
      { name: "国家", id: "100000" },
      filterArr[0],
    ];

    const res2: any = await nature()
      .then()
      .catch((e: string) => console.error(e));
    this.policyTypeArr = [{ natureName: "全部", id: "" }, ...res2.data.result];
  }
  selectProvince(item: any) {
    this.townArr = [];
    this.currentProvince = item.id;
    this.currentCity = "";
    this.currentTown = "";
    this.currentDept = "";
    if (item.children) {
      this.cityArr = item.children.filter((item: any) => item.name == "黄石市");
    } else {
      this.cityArr = [];
    }
    if (item.id) {
      this.getDeptData(item.id);
    }
    this.getData(0);
  }
  async selectCity(item: any) {
    this.currentCity = item.id;
    this.currentTown = "";
    this.currentDept = "";
    let childArr = await getAddressItemNum(item.id);
    this.townArr = childArr.data.result;
    if (item.id) {
      this.getDeptData(item.id);
    }
    this.getData(0);
  }
  async getDeptData(id: any) {
    const res: any = await getDeptNumber(id);
    this.deptArr = [{ departmentName: "全部", id: "" }, ...res.data.result];
  }
  selectTown(item: any) {
    this.currentTown = item.id;
    this.currentDept = "";
    if (item.id) {
      this.getDeptData(item.id);
    }
    this.getData(0);
  }
  selectDept(item: any) {
    this.currentDept = item.id;
    this.getData(0);
  }
  selectType(item: any) {
    this.currentType = item.natureName;
    this.getData(0);
  }
  selectYear(item: any) {
    this.currentYear = item.val;
    this.getData(0);
  }
  selectStatus(item: any){
    this.declareStatus = item.id;
    this.getData(0);
  }
  selectfundRange(item: any){
    this.currentFundRange = item.value;
    if(this.currentFundRange){
      let fundRangeStr = this.currentFundRange.substr(0,this.currentFundRange.length-1)
      let fundRangeArr = fundRangeStr.split("~")
      this.startSupportAmount = fundRangeArr[0]
      this.endSupportAmount = fundRangeArr[1]
    }else{
      this.startSupportAmount = ""
      this.endSupportAmount = ""
    }

    this.getData(0);
  }
  clickMarquee(options: any) {
    options.addressCode ? options.addressCode : this.cityId;
    this.current_option = options;
    this.getData(1);
  }
  search(options: any) {
    this.current_option = {
      ...this.current_option,
      ...options,
    };
    this.getData(1);
  }
  toDetail({ id, declareItemId }: any) {
    const { href } = this.$router.resolve({
      path: "/detail/apply",
      query: {
        projectId: declareItemId,
        directionId: id,
      },
    });

    window.open(href, "_blank");
  }
}
